import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { environment } from 'src/environments/environment'

export interface ModelUploadStatus {
  job_id: string
  file_name: string
  job_type: string
  submitted_at: string
  model_id?: number | null
  completed_at: string | null
  status: 'PROCESSING' | 'FINISHING' | 'COMPLETED' | 'FAILED' | 'NEEDS_ATTENTION'
}

@Injectable({ providedIn: 'root' })
export class ModelUploadService {
  // Shared by the Models summary and its existing shared-right-panel outlet.
  uploads: ModelUploadStatus[] = []
  selectedId: string | null = null
  lastChecked: Date | null = null
  error = false
  refreshing = false
  readonly refreshRequested = new Subject<void>()
  readonly labels = {
    PROCESSING: 'Queued / processing', FINISHING: 'Finishing', COMPLETED: 'Available',
    FAILED: 'Failed', NEEDS_ATTENTION: 'Needs attention'
  }
  readonly messages = {
    PROCESSING: 'Your upload was received and is queued or processing. You can keep working while it runs.',
    FINISHING: 'Your upload is being finalized. The model is not available yet.',
    COMPLETED: 'Your model has been added to your account and is available in Models.',
    FAILED: 'This upload could not be completed. Contact support before uploading it again.',
    NEEDS_ATTENTION: 'Your model is not available yet. Processing or delivery may be delayed. Contact support so we can check it.'
  }
  readonly icons = {
    PROCESSING: 'fa-clock', FINISHING: 'fa-circle-notch', COMPLETED: 'fa-circle-check',
    FAILED: 'fa-circle-xmark', NEEDS_ATTENTION: 'fa-triangle-exclamation'
  }
  constructor(private http: HttpClient) {}
  get selected() { return this.uploads.find(upload => upload.job_id === this.selectedId) }
  getUploads() { return this.http.get<ModelUploadStatus[]>(`${environment.api}/model-uploads`) }
  supportLink(upload: ModelUploadStatus): string {
    const subject = encodeURIComponent(`Model upload: ${upload.file_name}`)
    const body = encodeURIComponent(`Please check my model upload.\n\nReference: ${upload.job_id}\nFile: ${upload.file_name}\nStatus: ${this.labels[upload.status]}`)
    return `mailto:support@kartorium.com?subject=${subject}&body=${body}`
  }
}
